import { createApp } from 'vue';
import axios from 'axios';
import stickyMap, { destroyStickyMap } from './stick-map';
import theme from '../../../src/js/modules/theme';

function calcDistance(lat1, lon1, lat2, lon2) {
  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * lat2) / 180;
  const theta = lon1 - lon2;
  const radtheta = (Math.PI * theta) / 180;
  let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = (dist * 60 * 1.1515).toFixed(2);
  return dist;
}

export const assignDistance = (lat, lng) => {
  setTimeout(() => {
    const elements = document.querySelectorAll('.js-location-card');
    Array.prototype.forEach.call(elements, el => {
      const userLat = Number(lat);
      const userLng = Number(lng);
      const locationLat = Number(el.getAttribute('lat'));
      const locationLng = Number(el.getAttribute('lng'));

      const mile = el.querySelector('.js-location-card-mile');

      if (locationLat !== 0 || locationLng !== 0) {
        const dist = calcDistance(userLat, userLng, locationLat, locationLng);
        if (!mile) {
          return;
        }
        mile.innerHTML = dist;

        let distanceEle = el.querySelector('.sf-location-card__distance');
        if(distanceEle) {
          distanceEle.classList.remove('sf-location-card__distance');
        }
      }
    });
  }, 2000);
};

const locationList = async () => {
  const list = document.querySelector('#location-list');
  if (!list) {
    return;
  }

  const app = createApp({
    delimiters: ['${', '}'],
    data() {
      return {
        nextPage: 0,
        showSpinner: 1,
        total: 0,
        locations: [],
        userLat: '',
        userLng: ''
      };
    },
    mounted() {},
    methods: {
      loadMoreLocations() {
        axios.get(this.getEndpoint() + `?pg=${this.nextPage}`).then(response => {
          const apiData = response.data.data;
          const apiMeta = response.data.meta;

          this.locations = this.locations.concat(apiData);
          this.showSpinner = 0;
          this.nextPage = this.nextPage + 1;
          if (
              apiMeta.pagination.total_pages === apiMeta.pagination.current_page
          ) {
            this.nextPage = 0;
          }
        });

        setTimeout(() => {
          destroyStickyMap();
          stickyMap();
        }, 1000);

        assignDistance(this.userLat, this.userLng);
      },
      getEndpoint() {
        const currentSection = list.getAttribute('js-location-list');

        let api;

        if (currentSection === 'allResidential') {
          api = '/api/residential.json';
        } else if (currentSection == 'allHotpods') {
          api = '/api/hotpods.json';
        } else if (currentSection == 'allVirtualOffices') {
          api = '/api/virtual-offices.json';
        } else if (currentSection == 'allIndustrialUnits') {
          api = '/api/industrial-units.json';
        } else {
          api = '/api/locations.json';
        }

        return api;
      }
    },
    created() {
      axios.get(this.getEndpoint()).then(response => {
        const apiData = response.data.data;
        const apiMeta = response.data.meta;

        this.total = apiMeta.pagination.total;
        this.locations = this.locations.concat(apiData);

        this.showSpinner = 0;
        if (apiMeta.pagination.total_pages > 1) {
          this.nextPage = 2;
        }
      });

      if (navigator.geolocation && theme.locationAware(theme.brand())) {
        navigator.geolocation.getCurrentPosition(position => {
          this.userLat = position.coords.latitude;
          this.userLng = position.coords.longitude;
          assignDistance(this.userLat, this.userLng);
        });
      }
    }
  });

  app.mount(list);
};

export default locationList;
